import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=5c874386"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c874386')) {
      api.createRecord('5c874386', component.options)
    } else {
      api.reload('5c874386', component.options)
    }
    module.hot.accept("./Settings.vue?vue&type=template&id=5c874386", function () {
      api.rerender('5c874386', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Admin/Settings.vue"
export default component.exports